import { Component, Input } from '@angular/core';

/**
 * Generated class for the MiniGiftCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'mini-gift-card',
  templateUrl: 'mini-gift-card.html'
})
export class MiniGiftCardComponent {
  @Input() public item;

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/components/mini-gift-card/mini-gift-card.ts